import React from "react";

// Atom: Field Message. Inline validation/help text under a control. Default
// class is the shared error style; callers may pass a variant class (e.g. the
// phone-specific spacing) without changing the atom.
const FieldMessage = ({ className = "sidebar-quickform-error", children }) => (
    <span
        className={className}
        data-atomic="atom"
        data-atomic-name="field-message"
    >
        {children}
    </span>
);

export default FieldMessage;
